import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { FluentProvider } from '@fluentui/react-components';
import '@fontsource/inter/800.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/fredoka/600.css';
import App from './app/App';
import { initAuth, withTimeout } from './auth';
import { Loading, StartupError } from './app/Stuck';
import { theme } from './theme';
import { ENVIRONMENT_LABEL } from './config';
import './index.css';

if (ENVIRONMENT_LABEL) {
  document.title = `[${ENVIRONMENT_LABEL}] ${document.title}`;
}

const root = createRoot(document.getElementById('root')!);
const render = (node: React.ReactNode): void => root.render(<FluentProvider theme={theme} style={{ height: '100%' }}>{node}</FluentProvider>);

// Sign-in starts within 20 s, or the person gets a way out (try again, or reset this browser's sign-in).
render(<Loading label="Starting…" onRetry={() => window.location.reload()} />);
withTimeout(initAuth(), 20000, 'Signing in took too long.')
  .then(account => render(<App account={account} />))
  .catch((error: unknown) => {
    console.error(error);
    render(<StartupError message={`Sign-in could not start: ${String((error as Error)?.message ?? error)}`} onRetry={() => window.location.reload()} />);
  });
